// extracted by mini-css-extract-plugin
module.exports = {"Contentblock":"ContentBlock_Contentblock__3MCmy","InputWrapperStyles":"ContentBlock_InputWrapperStyles__34Rwp"};